/**
 * True when any field of `current` differs from `saved`, i.e. the row has edits that are not saved yet.
 * Missing and null values count as the same.
 */
export const hasStagedChanges = <T extends object>(current: T, saved: T): boolean => {
  const currentFields = current as Record<string, unknown>;
  const savedFields = saved as Record<string, unknown>;
  return Object.keys({ ...currentFields, ...savedFields }).some((key) =>
    JSON.stringify(currentFields[key] ?? null) !== JSON.stringify(savedFields[key] ?? null)
  );
};
